export default __webpack_public_path__ + "static/media/BCA17.c08165d7.jpg";